enum AvailableFeatures {
  RISK = "risk",
  COUNTERS = "counters",
  ORGANIZATION_MANAGEMENT = "organization-management",
  ENGINE_TRENDING = "engine-trending",
  SQUAWKS = "squawks",
  MAINTENANCE_INTELLIGENCE = "maintenance-intelligence",
  REPORTS = "reports",
  //   BINDER = "binder",
  //   TRAINING = "training",
  WEIGHT_AND_BALANCE = "weight-and-balance",
  PERFORMANCE = "performance",
  PREMIUM_MFRAT = "premium-mfrat",
}

const AvailableFeaturesLabels: Record<AvailableFeatures, string> = {
  [AvailableFeatures.MAINTENANCE_INTELLIGENCE]: "Maintenance Intelligence",
  [AvailableFeatures.SQUAWKS]: "Squawks",
  //   [AvailableFeatures.BINDER]: "Binder",
  [AvailableFeatures.REPORTS]: "Reports",
  [AvailableFeatures.RISK]: "Risk Assessments",
  //   [AvailableFeatures.TRAINING]: "Training & Certification",
  [AvailableFeatures.WEIGHT_AND_BALANCE]: "Weight & Balance",
  [AvailableFeatures.PERFORMANCE]: "Performance Analysis",
  [AvailableFeatures.COUNTERS]: "Counters",
  [AvailableFeatures.ENGINE_TRENDING]: "Engine Trending",
  [AvailableFeatures.ORGANIZATION_MANAGEMENT]: "Organization Management",
  [AvailableFeatures.PREMIUM_MFRAT]: "Premium MFRAT+ and DRAT+",
};

export { AvailableFeatures, AvailableFeaturesLabels };
